import React, { useState } from "react";
import RecordHeader from "./RecordHeader";
import CompareToolbar from "./CompareToolbar";
import StagesTable from "./StagesTable";
import CompareModal from "./CompareModal";

// one searched value: header + stages table + compare
//   onViewData(stage) is handled by the parent (it owns the data popup)
export default function RecordCard({ record, defaultExpanded = false, onViewData }) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const [picked, setPicked] = useState([]); // stageNum[]
  const [showCompare, setShowCompare] = useState(false);
  const [pickError, setPickError] = useState(false);

  const selectable = record.stages.filter((s) => s.found && s.data);
  const compareStages = record.stages.filter((s) => picked.includes(s.stageNum));

  const togglePick = (num) => {
    setPickError(false);
    setPicked((cur) =>
      cur.includes(num) ? cur.filter((n) => n !== num) : [...cur, num]
    );
  };

  const toggleAll = () => {
    setPickError(false);
    setPicked(picked.length === selectable.length ? [] : selectable.map((s) => s.stageNum));
  };

  const handleCompare = () => {
    if (picked.length < 2) {
      setPickError(true);
      setShowCompare(false);
      return;
    }
    setShowCompare(true);
  };

  console.log(record)

  return (
    <div className="card shadow-sm">
      <RecordHeader
        record={record}
        expanded={expanded}
        onToggle={() => setExpanded((v) => !v)}
      />

      {expanded && (
        <div className="card-body bg-light">
          <CompareToolbar
            count={picked.length}
            showError={pickError}
            onCompare={handleCompare}
          />

          <StagesTable
            stages={record.stages}
            recordId={record.id}
            category={record.category}
            picked={picked}
            onTogglePick={togglePick}
            onToggleAll={toggleAll}
            onViewData={onViewData}
          />

          {showCompare && compareStages.length >= 2 && (
            <CompareModal
              record={record}
              stages={compareStages}
              onViewData={onViewData}
              onClose={() => setShowCompare(false)}
            />
          )}
        </div>
      )}
    </div>
  );
}
